import type { Store } from "@/stores";
import { useMapStoreStateToClientState } from "@/hooks/useMapStoreStateToClientState";

// custom hook to read the props
const useStateOfFilters = (store: Store, isRoundTrip: boolean) => {
  return useMapStoreStateToClientState(
    store,
    (store: Store) => {
      const pageStore = isRoundTrip
        ? store.appStore.stepByStepSearchPage.currentStepStore
        : store.appStore.completeSearchPage;
      return {
        requestAirports: pageStore.searchResults.searchRequest.requestAirports,
        reset: pageStore.filters.reset,
        isDirty: pageStore.filters.isDirty,
        totalFlightsCount: pageStore.totalFlightsCount,
        filteredFlightsCount: pageStore.filteredFlightsCount,
        filters: pageStore.filters,
        toggleAMFormat: pageStore.filters.toggleAMFormat,
        isAMFormat: pageStore.filters.isAMFormat,
        $resources: store.appStore.$resources,
        searchType: pageStore.searchResults.searchRequest.searchType,
        currentStep:
          store.appStore?.stepByStepSearchPage?.currentStep || undefined,
        quickFilters: pageStore.filters.quickFilters,
        toggleQuickFilter: pageStore.filters.toggleQuickFilter,
        set12HoursTimeFormat: store.uiStore.set12HoursTimeFormat,
        selectedSortKey: pageStore.sort.selectedItem,
        isLoading: pageStore?.searchResults?.isLoading,
        isCompleted: pageStore?.searchResults?.isCompleted,
        isResourcesFetched: store.appStore.flightInfo.resources.isFetched,
        restorePreservedFilters: isRoundTrip
          ? store.appStore.stepByStepSearchPage.restorePreservedFilters
          : store.appStore.completeSearchPage.restorePreservedFilters,
      };
    },
    [isRoundTrip],
  );
};

export default useStateOfFilters;
